import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/svg/lp_academy_s3_icon1.svg';
import icon2 from '../../theme/assets/svg/lp_academy_s3_icon2.svg';
import icon3 from '../../theme/assets/svg/lp_academy_s3_icon3.svg';


const AcademyS3 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>{t('3 главных преимущества')}</span> <br/>{t('Академии OMT')} </div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon1} alt={t('Системное понимание рынка, а не хаотичные знания')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Системное понимание рынка, а не хаотичные знания')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы даём структурированную модель работы в криптопространстве: от понимания технологий до анализа проектов и управления рисками. Участники получают не фрагменты информации, а целостную стратегию действий.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon2} alt={t('Безопасность и снижение ошибок')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Безопасность и снижение ошибок')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Программа построена на анализе опыта более 100 000 человек и их типичных ошибок. Мы заранее показываем риски и ошибки инвесторов, формируем дисциплину и даём инструменты, которые защищают капитал и время.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon3} alt={t('Доступ к лучшим возможностям экосистемы')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Доступ к лучшим возможностям экосистемы')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Академия — это подготовительный уровень перед участием в сильных проектах. Мы формируем качественных участников для проектов и открываем людям доступ к отобранным возможностям внутри экосистемы OMT.')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademyS3;




